<template>
  <b-row class="global-spinner-container" align-v="center" align-h="center" v-if="getGlobalSpinnerShow">
    <div id="spinnerContainer">
      <img src="/static/img/loading.gif">
    </div>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalSpinner',
  props: {
    colorAnimation: { type: String, default: '#428bca' },
    sizeAnimation: { type: Number, default: 60 },
    speedAnimation: { type: Number, default: 1000 },
  },
  computed: {
    ...mapGetters(['getGlobalSpinnerShow']),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .global-spinner-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10002;
    pointer-events: none;
    background: rgba(0,0,0,.7);
  }

  #spinnerContainer {
    background-color: white;
    border-radius: 5px;
    padding: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/GlobalSpinner.vue